module.exports = __webpack_public_path__ + "img/facebook-logo-32.624d832c.svg";